import { useEffect, useState, useRef } from "react";
import AlertComponent from "../alert-component/alert-component";
import AccordionComponent from "../accordian-component/accordion-component";
import ShipmentType from "../shipment-type/ShipmentType";
import {Search} from '@deere/fuel-react/Search';
import { useOktaAuth } from "@okta/okta-react";
import SupplierSelectComponent from "../supplier-select-component/SupplierSelectComponent";
import axios from "axios";
import Alert from "@mui/material/Alert";
import { FileInput } from "@deere/fuel-react/FileInput";
import {FileList} from '@deere/fuel-react/FileList';
import {FileListItem} from '@deere/fuel-react/FileListItem';
import {FileValidationList} from '@deere/fuel-react/FileValidationList';
import {FileValidationListItem} from '@deere/fuel-react/FileValidationListItem';

import {
  Typography,
  Box,
  CircularProgress,
  Grid,
  Card,
  CardContent,
} from "@mui/material";
import Button from '@mui/material/Button';
import ModalComponent from "../modal-component/ModalComponent";
import "./TestEdiTransComponent.css";
import { useUserDetails } from "../../hooks";


const TestEdiTransComponent = (props) => {
  const {
    invalidFileName,
    invalidFileType,
    setInvalidFileType,
    setInvalidFileName,
    setTimeAlert,
    setProcessingTime,
    processingTime,
    setSystemError,
    useremail,
    username,
    userid,
    usertype,
    refreshHandler,
    setShipmentAlert,
  } = props;
  const { oktaAuth } = useOktaAuth();
  const [businessValidationResult, setBusinessValidationResult] =
    useState(null); //useState Hook
  const [technicalValidationResult, setTechnicalValidationResult] =
    useState(null);
  const [allFieldsSelected, setAllFieldsSelected] = useState(false);
  const [supplierName, setSupplierName] = useState(null);
  const [count, setCount] = useState(0);
  const [lastTestedDate, setLastTestedDate] = useState(null);
  const [isLoading, setLoading] = useState(false);
  const [isHideMainPage, setIsHideMainPage] = useState(true);
  const [businessValidationExists, setBusinessValidationExists] =
    useState(false);
  const [technicalValidationExists, setTechnicalValidationExists] =
    useState(false);
  const [resultFileName, setResultFileName] = useState(null);
  const [transactionType, setTransactionType] = useState(null);
  const [supplierNumber, setSupplierNumber] = useState(null);
  const [shipmentType, setShipmentType] = useState(null);
  const [file, setFile] = useState(null);
  const [seconds, setSeconds] = useState(1);
  const [requestIsSuccessful, setRequestIsSuccessful] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [dataEdiError, setDataEdiError] = useState(false);
  const TXNTypeList = ["856 - Advance Ship Notice", "810 - Invoice"];
  const { oktaDetails, setSupplierList, supplierList } = useUserDetails();

  const searchSuppliers = (e) => {
    //for John Deere internal Employee, needs to submit atleast 4 digits
    if (e.target.value.length >= 3) {
      oktaDetails.usertype !== "Supplier Employee" &&
        axios
          .get(
            process.env.REACT_APP_API_BASE_URL +
              "/getSupplierInfoEmployee?queryString=" +
              e.target.value,
            {
              params: {
                _limit: 5,
              },
              headers: {
                Authorization: "Bearer " + oktaAuth.getAccessToken(),
              },
            }
          )
          .then((response) => {
            const filteredResponse = response.data.map(
              (item) => item.supplierNumber + " - " + item.supplierName
            );
            setSupplierList(filteredResponse);
          })
          .catch((error) => {
            setSystemError(true);
          });
    }
  };
const ref = useRef();

  //onChange of File Input

  const validateFile = (file) => {
    const isValidExtension = file.name.endsWith('.txt') || file.name.endsWith('.edi');
    setInvalidFileType(!isValidExtension);


    if (isValidExtension) {
      setFile(file);
      getProcessingTime(file);
    } else {
      setFile(null);
      setAllFieldsSelected(false);
    }
  };


  const onFileChange = (files) => {
    console.log(files)
    const selectedFile = files[0];

    if (!selectedFile) {
      setFile(null);
      return;
    }

    const isValidExtension = selectedFile.name.endsWith('.txt') || selectedFile.name.endsWith('.edi');
    const isValidNameLength = selectedFile.name.length - 4 <= 30;

    setInvalidFileType(!isValidExtension);
    setInvalidFileName(!isValidNameLength);

    if (isValidExtension && isValidNameLength) {
      setFile(selectedFile);
      getProcessingTime(selectedFile);
    } else {
      setFile(null);
    }
  };

  const handleInputChange = (event) => {
    console.log(event)
    const files = event.target.files;
    if (files && files.length > 0) {
      onFileChange(Array.from(files));
    }
  };


  const refreshHandler1 = () => {
    setShowModal(false);
    window.location.reload();
  };

  const updataeModal = async () => {
    setShowModal(false);
    const testformData = new FormData();
    testformData.append("supplierId", supplierNumber);
    testformData.append("file", file);
    testformData.append("transactionType", transactionType);
    testformData.append("email", useremail);
    testformData.append("supplierName", username);
    testformData.append("userId", userid);
    testformData.append("palletType", shipmentType);
    setLoading(true);
    setIsHideMainPage(false);
    await axios
      .post(
        process.env.REACT_APP_API_BASE_URL + "/bothValidations",
        testformData,
        {
          headers: {
            Authorization: "Bearer " + oktaAuth.getAccessToken(),
          },
        }
      )
      .then(
        (response) => {
          setLoading(false);
          const temp = response.data;
          //extract the name of the file as stored in S3
          if (
            temp.businessValidationExists === true ||
            temp.technicalValidationStatus === "Failure"
          ) {
            let index = temp.htmlFileUrl.lastIndexOf("/") + 1;
            let tempFileName = temp.htmlFileUrl.slice(index);
            setResultFileName(tempFileName);
          }
          if (temp.businessValidationExists === true) {
            //only if business validation exists
            setBusinessValidationExists(true);
            let tempBusinessValidationResult;
            //format the buisness validation result
            if (JSON.stringify(response.data.errorResponse) !== "{}") {
              tempBusinessValidationResult = temp.errorResponse
                .replace("{", "")
                .replace("}", "")
                .replace('"', "")
                .replace('"', "")
                .replace(/\\n/g, "")
                .split("$");
              setBusinessValidationResult(tempBusinessValidationResult);
            } else {
              setBusinessValidationResult(null);
            }
          }
          if (temp.technicalValidationStatus === "Failure") {
            //only if technical validation exists
            setTechnicalValidationExists(true);
            let tempTechnicalValidationResult;
            //format the buisness validation result
            if (JSON.stringify(response.data.errorResponse) !== "{}") {
              tempTechnicalValidationResult = temp.technicalValidationResponse
                .replace("{", "")
                .replace("}", "")
                .replace('"', "")
                .replace('"', "")
                .replace(/\\n/g, "")
                .split("$");
              setTechnicalValidationResult(tempTechnicalValidationResult);
            } else {
              setTechnicalValidationResult(null);
            }
          }

          //after results are recieved
          setRequestIsSuccessful(!requestIsSuccessful);
        },
        (error) => {
          setDataEdiError(true);
          setSystemError(true);
          setLoading(false);
        }
      );
  };

  //to get the processing time for uploaded file

  async function getProcessingTime(fileData) {
    const fileSize = fileData.size;
    const fileformData = new FormData();
    fileformData.append("fileSize", Math.round(fileSize / 1024));
    await axios
      .post(
        process.env.REACT_APP_API_BASE_URL + "/getProcessingTimeWithFilesize",
        fileformData,
        {
          headers: {
            Authorization: "Bearer " + oktaAuth.getAccessToken(),
          },
        }
      )
      .then((response) => {
        let temp = response.data;
        setProcessingTime(temp);
      })
      .catch((error) => {
        setSystemError(true);
        setTimeAlert(false);
      });
  }

  //after clicking the "Start Test" button
  async function uploadHandler(event) {
    setTimeAlert(false);
    if (processingTime <= 60) {
      setLoading(true);
      setIsHideMainPage(false);
      setShowModal(false);
      updataeModal();
    } else {
      setShowModal(true);
    }
  }

  useEffect(() => {
    let myInterval = setInterval(() => {
      if (isLoading) {
        setSeconds((seconds) => seconds + 1);
      }
    }, 1000);
    return () => {
      clearInterval(myInterval);
    };
  }, [isLoading]);

  useEffect(() => {
    //finds the count of all tests and recent test date

    console.log(transactionType)
    console.log(file)
    console.log(supplierNumber)

    if (file === null) {
      setAllFieldsSelected(false);
    } else if (transactionType && supplierNumber && file) {
      if (transactionType !== "856") {
        setAllFieldsSelected(true);
      } else {
        if (shipmentType === null) {
          setAllFieldsSelected(false);
        } else {
          setAllFieldsSelected(true);
        }
      }
    }
    const formData = new FormData();
    supplierNumber && formData.append("supplierId", supplierNumber);
    formData.append("transactionType", transactionType);

    transactionType &&
      supplierNumber &&
      axios
        .post(
          process.env.REACT_APP_API_BASE_URL + "/getNumberOfTimesTested",
          formData,
          {
            headers: {
              Authorization: "Bearer " + oktaAuth.getAccessToken(),
            },
          }
        )
        .then(
          (response) => {
            const timestamp = new Date(response.data[0].max);
            setLastTestedDate(timestamp.toString());
            setCount(response.data[0].count);
          },
          (error) => {
            setSystemError(true);
          }
        );
  }, [
    transactionType,
    setTransactionType,
    supplierNumber,
    setSupplierNumber,
    file,
    setFile,
    oktaAuth,
    setSystemError,
    shipmentType,
  ]);
  //For showing select shipment type alert
  useEffect(() => {
    if (
      transactionType != null &&
      transactionType === "856" &&
      supplierNumber != null &&
      file != null &&
      shipmentType == null
    )
      setShipmentAlert(true);
    else setShipmentAlert(false);
  }, [transactionType, setShipmentAlert, supplierNumber, shipmentType, file]);
  const transactionChangeHandler = (event) => {
  if (!event || !TXNTypeList.includes(event)) {
    setTransactionType(null);
    setAllFieldsSelected(false)
  } else {
    setTransactionType(event.slice(0, 3));
  }
  };

  const supplierChangeHandler = (event) => {
    if (!event || !supplierList.includes(event)) {
      setSupplierNumber(null);
      setSupplierName(null);
    setAllFieldsSelected(false)
  } else {
      setSupplierNumber(event.slice(0, 10));
      setSupplierName(event.slice(13));
  }
  };
  const downloadTestedFile = () => {
    const element = document.createElement("a");
    const newFile = new Blob([file], { type: "text/plain" });
    element.href = URL.createObjectURL(newFile);
    element.download = file.name;
    document.body.appendChild(element);
    element.click();
  };
  //Download error report
 const donwloadReport = async () => {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_API_BASE_URL}/downloadfilefroms3/${resultFileName}`,
      {
        headers: {
          Authorization: "Bearer " + oktaAuth.getAccessToken(),
        },
        responseType: "blob", // importante para archivos
      }
    );

    const element = document.createElement("a");
    const newFile = new Blob([response.data], { type: "text/html" });
    element.href = URL.createObjectURL(newFile);
    element.download = resultFileName;
    document.body.appendChild(element);
    element.click();
    document.body.removeChild(element);
  } catch (error) {
    console.error("Error al descargar el archivo:", error);

  }
};

  return (
    <>
      {requestIsSuccessful ? (
        <div>
          {
            <AlertComponent
              businessValidationExists={businessValidationExists}
              technicalValidationExists={technicalValidationExists}
              businessValidationStatus={businessValidationResult}
              errordownload={donwloadReport}
            />
          }
          <br />

          {businessValidationResult &&
          businessValidationResult[0] === "" ? null : (
            <div>
              <AccordionComponent
                errors={businessValidationResult}
                token={oktaAuth.getAccessToken()}
                accordionLabel="Check Business Compliance Errors"
              />
              <br />
            </div>
          )}
          {technicalValidationResult &&
          technicalValidationResult[0] === "" ? null : (
            <div>
              <AccordionComponent
                errors={technicalValidationResult}
                token={oktaAuth.getAccessToken()}
                accordionLabel="Check Technical Compliance Errors"
              />
            </div>
          )}
          <h5 className="entryLabel">John Deere Supplier Number</h5>
          {supplierName ? (
            <p>
              {supplierNumber} - {supplierName}
            </p>
          ) : (
            <p>{supplierNumber}</p>
          )}

          <h5 className="entryLabel">Transaction Type</h5>
          <p>
            {transactionType}{" "}
            <Button variant="text">
              {" "}
              <a
                target="_blank"
                rel="noopener noreferrer"
                href={process.env.REACT_APP_STANDARD_GUIDELINES_LINK}
              >
                View Guidelines and Standards
              </a>
            </Button>
          </p>

          <h5 className="entryLabel">Shipment Type</h5>
          <p>{shipmentType}</p>

          <h5 className="entryLabel">File Tested </h5>
          <Button
            className="testedFile"
            variant="text"
            onClick={downloadTestedFile}
          >
            {file.name}
          </Button>
          <br />
          <div>
            <Button
              variant="primary"
              className="downloadbtn"
              onClick={refreshHandler}
            >
              Start New Test
            </Button>
          </div>
        </div>
      ) : (
        <Card>
          <CardContent>
            {/* To show loader when generating reports */}
            {isLoading && (
              <>
                <Box
                  alignItems="center"
                  display="flex"
                  flexDirection="column"
                  height={180}
                  justifyContent="center"
                  p={4}
                >
                  <CircularProgress />

                  <Typography size="xl" component="p" gutterBottom>
                    {"Testing Advanced Ship Notice"}
                  </Typography>
                  <Typography size="md" component="p" gutterBottom>
                    {"This will take about"} {processingTime}{" "}
                    {
                      " seconds. You may navigate away and the results will be emailed to you."
                    }
                  </Typography>
                  <Typography size="sm" component="p" gutterBottom>
                    {"Time elapsed: "} <b>{seconds}</b> {" seconds"}
                  </Typography>
                </Box>
              </>
            )}
            {isHideMainPage && (
              <>
                <p className="entryLabel">John Deere Supplier Number</p>
                {
                  <Grid container spacing={2}>
                    <Grid item size={{xs:4, sm:4, md:8, lg:8, xl:8}}>
                      <div className="row">
                        <div className="col ">
                          <SupplierSelectComponent
                            userType={usertype}
                            supplierList={supplierList}
                            supplierChangeHandler={supplierChangeHandler}
                            handleKeyDown={searchSuppliers}
                          />
                        </div>
                      </div>
                    </Grid>
                  </Grid>
                }
                <p className="entryLabel">Transaction Type</p>
                <Grid container>
                  <Grid item size={{xs:4, sm:4, md:8, lg:8, xl:8}}>
                        <Search
                          placeholder={'Search and select'}
                          variant={'onWhite'}
                          options={TXNTypeList.map((e) => {
                            return {
                              value: e,
                              label: e,
                            };
                            
                          })}
                          slotProps={{
                            search: {
                                onInputChange: (_event, value) => {
                                    transactionChangeHandler(value);
                                },   
                            }
                          }}
                        />
                  </Grid>
                  <Grid item size={{xs:4, sm:4, md:8, lg:8, xl:8}}>
                    <Button variant="text">
                          <a
                            target="_blank"
                            rel="noopener noreferrer"
                            href={
                              process.env.REACT_APP_STANDARD_GUIDELINES_LINK
                            }
                          >
                            View Guidelines and Standards
                          </a>
                        </Button>
                  </Grid>
                  
                </Grid>
                {supplierNumber && transactionType ? (
                  <Alert
                    className="alert-label"
                    severity="info"
                    sx={{ width: "41%" }}
                  >
                    <Typography variant="button" display="block" gutterBottom>
                      Tested {count} Previous Times
                    </Typography>
                    {count === 0 ? null : (
                      <Typography variant="button" display="block" gutterBottom>
                        {" "}
                        Last tested on {lastTestedDate}
                      </Typography>
                    )}
                  </Alert>
                ) : null}
                {transactionType === "856" && (
                  <>
                    <p className="entryLabel">Shipment Type</p>
                    <ShipmentType
                      setShipmentType={setShipmentType}
                      shipmentType={shipmentType}
                    ></ShipmentType>{" "}
                  </>
                )}
                <p className="entryLabel">
                  File to Test{" "}
                  <span className="textFormat">(.txt format required)</span>
                </p>
                <div className="fieldSize">
                  <FileInput
                    id="file-input"
                    name="file-input"
                    ref={ref}
                    inputProps={{ accept: '.txt,.edi' }}
                    onChange={(event) => {
                      const files = event.target.files;
                      if (files && files.length > 0) {
                        validateFile(files[0]); 
                      } else {
                        setFile(null);
                      }
                    }}
                    renderFileList={(fileList) => (
                      <FileList>
                        {fileList?.map((file) => (
                          <FileListItem
                            key={file.name}
                            text={file.name}
                            validationState={
                              invalidFileType ? 'invalid' : 'valid'
                            }
                          />
                        ))}
                      </FileList>
                    )}
                    renderValidations={() => (
                      <>
                        <Typography component="div" variant="labelMedium">
                          File Format
                        </Typography>
                        <FileValidationList>
                          <FileValidationListItem
                            text="File Type (.txt, .edi)"
                            state={invalidFileType ? 'invalid' : 'valid'}
                          />
                        </FileValidationList>
                      </>
                    )}
                  />

                </div>
                <br />
                <div>
                  <Button
                    variant={'primary'}
                    disabled={!allFieldsSelected}
                    onClick={uploadHandler}
                  >
                    Start Test
                  </Button>
                </div>
              </>
            )}
            {dataEdiError && (
              <Typography
                variant="text"
                display="block"
                gutterBottom
                className="EdiDataError"
              >
                Something Went Wrong. Please Contact Administrator.
              </Typography>
            )}
          </CardContent>
        </Card>
      )}
      <ModalComponent
        show={showModal}
        processingTime={processingTime}
        refreshHandler={refreshHandler1}
        useremail={useremail}
        cancelModal={updataeModal}
      />
    </>
  );
};

export default TestEdiTransComponent;
